import React from 'react';
import { css } from '@emotion/react';

import { mediaQueries } from '~src/main/theme/media-queries';

import { DialogCloseButton } from './dialog-close-button';

interface DialogLayoutProps {
  title: string | React.ReactNode;
  onClose: () => void;
}

export const DialogLayout: React.FC<DialogLayoutProps> = ({ title, children, onClose }) => {
  return (
    <div css={styles.wrapper}>
      <div css={styles.header}>
        <div aria-level={2} css={styles.title} role="heading">
          {title}
        </div>
        <DialogCloseButton css={styles.closeButton} onClick={() => onClose()} />
      </div>
      <div css={styles.body} data-test="modal-body">
        {children}
      </div>
    </div>
  );
};

const styles = {
  wrapper: css({
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
    boxSizing: 'border-box',
    padding: '40px',
    [mediaQueries.S]: {
      padding: '16px',
    },
  }),
  header: css({
    minHeight: '22px',
    display: 'flex',
    marginBottom: '25px',
    [mediaQueries.S]: {
      minHeight: '20px',
      fontSize: '16px',
      lineHeight: '20px',
      marginBottom: '22px',
    },
  }),
  title: css({
    flexGrow: 1,
    fontVariationSettings: "'wght' 500",
    fontSize: '18px',
    lineHeight: '22px',
    [mediaQueries.S]: {
      fontSize: '16px',
      lineHeight: '20px',
    },
  }),
  closeButton: css({
    marginLeft: '16px',
    marginRight: '6px',
  }),
  body: css({
    overflow: 'auto',
    flexGrow: 1,
    fontSize: '14px',
    lineHeight: '20px',
  }),
};
